import { connect } from 'react-redux';
// import { bindActionCreators } from 'redux';
import SelectMany from './SelectMany';

const mapStateToProps = ({ estimateBuilder }) => {
  const { estimates } = estimateBuilder.entities;

  const sharableEstimates = estimates.allIds
    .filter(givenId => estimates.byId[givenId].sharedEmail === null);

  const sharedEstimates = estimates.allIds
    .filter(givenId => estimates.byId[givenId].sharedEmail !== null);

  return {
    sharableEstimates,
    sharedEstimates,
    selectionCount: estimateBuilder.share.selection.length,
  };
};

export default connect(mapStateToProps)(SelectMany);
